export default "__VITE_ASSET__BXovTq2s__"